
// * ========================================================================
// * ages per day chart and table
// * ========================================================================

import CovidChart from './covid-chart.js';
import moment from 'moment';
import storage from './../storage';

const agesPercentage = (function(){
    let thisChart = null;
    let chartFirstDate = null;
    const average = (arr) => arr.reduce((a, b) => a + b) / arr.length;

    function createChartData(data, options, selected) {
        const datasets = [];
        const dates = {};
        const dataOrder = {
            '00-10': 0,
            '10-20': 1,
            '20-30': 2,
            '30-40': 3,
            '40-50': 4,
            '50-60': 5,
            '60-70': 6,
            '70-80': 7,
            '80': 8
        };

        //var debugDate = moment().add('-1','day');

        let dayIdx = 0;
        for (let day of data.agesPerDay) {
            if (typeof dates[day.date] === 'undefined') {
                dates[day.date] = moment(day.date);
                dates[day.date].set({
                    hour: 0,
                    minute: 0,
                    second: 0
                });

                const newDate = dates[day.date];
                if (newDate >= chartFirstDate) {
                    let datasetIdx = 0;
                    for (let age of day.ages) {
                        if (typeof datasets[datasetIdx] === 'undefined') {
                            datasets.push({
                                label: age.name,
                                id: age.slug,
                                fill: false,
                                borderColor: options.chartColors[datasetIdx],
                                count: age.count,
                                data: [],
                                type: 'LineWithLine',
                                selected: selected && Array.isArray(selected) ? selected.indexOf(age.slug) !== -1 : true,
                                order: dataOrder[age.slug],
                                pointRadius: 0,
                                tension: 0.4
                            });
                        }

                        let firstDay = dayIdx - 6;
                        firstDay = firstDay < 0 ? 0 : firstDay;

                        let pastWeekTotal = 0;
                        let pastWeekTotalAgeValue = 0;
                        const pastWeekValues = [];
                        for (let x = firstDay; x <= dayIdx; x++) {
                            const dayCount = data.agesPerDay[x].count;
                            pastWeekTotal += dayCount;

                            const dayAgeCount = data.agesPerDay[x].ages[datasetIdx].count;
                            pastWeekTotalAgeValue += dayAgeCount;

                            const dayPercentage = dayAgeCount / dayCount * 100;

                            pastWeekValues.push(dayPercentage);
                        }

                        let totalWeekAverage = pastWeekTotalAgeValue / pastWeekTotal * 100;
                        totalWeekAverage = Math.round(totalWeekAverage * 10) / 10;

                        let weekAverage = pastWeekValues.length ? average(pastWeekValues) : 0;
                        weekAverage = Math.round(weekAverage * 10) / 10;

                        if (!isNaN(totalWeekAverage)) {
                            //let percentage = age.count / day.count * 100;
                            datasets[datasetIdx].data.push({
                                x: newDate,
                                y: totalWeekAverage
                            });
                        }

                        datasetIdx++;
                    }
                }
            }

            dayIdx++;
        }

        return datasets;
    }

    function getChartFirstDay(data) {
        const dataFirstDate = moment(data.ages[0].days[0].date).add('7','day'); // 7 day average => 7 days after first actual data date
        chartFirstDate = window.config.firstDayValues['ages']; // Current chart first date (user selected)

        if (chartFirstDate < dataFirstDate) {
            chartFirstDate = dataFirstDate;
        }

        return chartFirstDate;
    }

    /**
     * Initialize
     *
     * @param {Object} data - covid data
     */
    function init(data) {
        chartFirstDate = getChartFirstDay(data);

        // Initially selected
        let selectedAges = storage.getData('ages-percentage-chart_multiselect');
        if (!selectedAges || !Array.isArray(selectedAges)) {
            selectedAges = null;
        }

        const datasets = createChartData(data, window.config, selectedAges);

        thisChart = new CovidChart('ages-percentage-chart', {
            datasets,
            chartOptions: {
                type: 'line',
                options: {
                    plugins: {
                        tooltip: {
                            intersect: false,
                            mode: 'index',
                            callbacks: {
                                label: function(tooltipItem) {
                                    let label = tooltipItem.dataset.label + ': ' || '';
                                    label = label + tooltipItem.formattedValue + '%';

                                    // Newest value is last
                                    var prevIndex = tooltipItem.index - 1;
                                    if (typeof tooltipItem.dataset.data[prevIndex] !== 'undefined') {
                                        var prevValue = tooltipItem.dataset.data[prevIndex].y;
                                        let change = Math.round((tooltipItem.raw.y - prevValue) * 100) / 100;
                                        change = change >= 0 ? '+'+change : change;

                                        if (!isNaN(change)) {
                                            label += ' ('+change+'%)';
                                        }
                                    }

                                    return label;
                                },
                            },
                            itemSort: function(a, b, data) {
                                return b.yLabel > a.yLabel ? 1 : -1;
                            }
                        },
                    },
                    scales: {
                        x: {
                            type: 'timeseries',
                            time: {
                                unit: 'day',
                                displayFormats: {
                                    day: 'D.M',
                                }
                            }
                        },
                        y: {
                            ticks: {
                                precision: 0,
                                min: 0
                            }
                        }
                    }
                }
            },
            config: window.config,
            tooltips: {
                elementId: 'ages-percentage-chart-tooltip'
            },
            multiselect: {
                requireCount: false,
                valueType: 'string',
                idField: 'id',
                colorField: 'borderColor',
                inputName: 'ages-percentage-multiselect',
                selectElemId: 'ages-percentage-multiselect',
                colorElemId: 'ages-percentage-multiselect-colors',
                countElemId: 'ages-percentage-multiselect-count',
                selectAllElemId: 'ages-percentage-multiselect-select-all',
                clearAllElemId: 'ages-percentage-multiselect-clear-all'
            },
            responsive: ['aspectRatio']
        });
    }

    function reload(data) {
        // New first date value
        chartFirstDate = getChartFirstDay(data);
        const datasets = createChartData(data, window.config);

        // Update datasets
        thisChart.updateDatasets(datasets, true);
    }

    return {
        init,
        reload
    }

})();

export default agesPercentage;
